import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { webColors, webBorderRadius, webShadows } from '../../../../constants/webStyles';

const StepSuccessWeb = ({ navigation }) => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View style={styles.successIcon}>
          <Text style={styles.successCheckmark}>✓</Text>
        </View>
        <Text style={styles.successTitle}>Welcome to SuperMedic!</Text>
        <Text style={styles.successMessage}>
          Your account has been created successfully.{'\n'}
          Complete your profile to start applying for jobs.
        </Text>
        <TouchableOpacity
          style={styles.btnDashboard}
          onPress={() => navigation.reset({
            index: 0,
            routes: [{ name: 'HomeScreen' }],
          })}
        >
          <Text style={styles.btnDashboardText}>Go to Dashboard</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: webColors.cardBackground,
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 40,
  },
  content: {
    alignItems: 'center',
    maxWidth: 480,
    width: '100%',
  },
  successIcon: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: '#22c55e',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    shadowColor: '#22c55e',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.3,
    shadowRadius: 25,
  },
  successCheckmark: {
    fontSize: 40,
    color: '#ffffff',
    fontWeight: '700',
  },
  successTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 12,
    textAlign: 'center',
  },
  successMessage: {
    fontSize: 16,
    color: webColors.textMuted,
    textAlign: 'center',
    lineHeight: 26,
    marginBottom: 32,
  },
  btnDashboard: {
    width: '100%',
    backgroundColor: webColors.primary,
    paddingVertical: 16,
    borderRadius: webBorderRadius.medium,
    alignItems: 'center',
    ...webShadows.button,
  },
  btnDashboardText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
  },
});

export default StepSuccessWeb;
